import { LegalLayout, Lang, Sec, P, Bullets, Divider, CONTACT_EMAIL, SITE_URL } from '@/components/LegalLayout';

export default function Privacy() {
  return (
    <LegalLayout
      title="Polityka Prywatności / Privacy Policy"
      subtitle="Life Leverage OS — Pewnosc Siebie AI"
      updated="Ostatnia aktualizacja / Last updated: czerwiec 2026 / June 2026"
    >
      <Lang code="PL" label="Polski">
        <Sec title="Wprowadzenie">
          <P>
            Life Leverage OS („Aplikacja”) to osobiste centrum dowodzenia do zarządzania celami,
            zadaniami, projektami, nawykami i finansami. Aplikacja jest dostarczana przez
            Pewnosc Siebie AI („Deweloper”, „my”). Niniejsza Polityka Prywatności wyjaśnia, jakie
            dane zbieramy, w jaki sposób je wykorzystujemy oraz jakie masz prawa.
          </P>
        </Sec>
        <Sec title="Jakie dane zbieramy">
          <Bullets
            items={[
              'Dane konta i logowania: adres e-mail oraz podstawowe dane profilu (np. imię, ustawienia celu dochodowego).',
              'Treści wprowadzane przez użytkownika: cele, zadania, projekty, nawyki oraz wpisy finansowe, które samodzielnie tworzysz w aplikacji.',
              'Dane techniczne i diagnostyczne (jeśli dotyczy): podstawowe informacje o błędach i działaniu aplikacji, wykorzystywane wyłącznie w celu zapewnienia bezpieczeństwa i stabilności.',
            ]}
          />
        </Sec>
        <Sec title="Jak wykorzystujemy dane">
          <Bullets
            items={[
              'udostępnianie i działanie funkcji aplikacji,',
              'umożliwienie logowania i dostępu do konta,',
              'synchronizacja Twoich danych między sesjami i urządzeniami,',
              'obsługa zapytań i wsparcie techniczne,',
              'zapewnienie bezpieczeństwa i ochrona przed nadużyciami.',
            ]}
          />
        </Sec>
        <Sec title="Sprzedaż danych">
          <P>Nie sprzedajemy Twoich danych osobowych żadnym podmiotom trzecim.</P>
        </Sec>
        <Sec title="Funkcje AI">
          <P>
            Aplikacja zawiera funkcje sztucznej inteligencji, które mogą przetwarzać wprowadzone
            przez Ciebie treści w celu generowania sugestii, podsumowań i propozycji kolejnych
            kroków. Szczegóły opisaliśmy w Informacji o AI.
          </P>
        </Sec>
        <Sec title="Przechowywanie i usuwanie danych">
          <P>
            Przechowujemy Twoje dane tak długo, jak długo posiadasz aktywne konto. W dowolnym
            momencie możesz poprosić o usunięcie konta i danych za pośrednictwem strony „Usuwanie
            konta” lub kontaktując się z nami pod adresem {CONTACT_EMAIL}.
          </P>
        </Sec>
        <Sec title="Kontakt">
          <P>
            Pewnosc Siebie AI · {CONTACT_EMAIL} · {SITE_URL}
          </P>
        </Sec>
        <Sec title="Zmiany w Polityce">
          <P>
            Możemy okresowo aktualizować niniejszą Politykę. Zaktualizowana wersja będzie zawsze
            dostępna pod tym adresem.
          </P>
        </Sec>
      </Lang>

      <Divider />

      <Lang code="EN" label="English">
        <Sec title="Introduction">
          <P>
            Life Leverage OS (the “App”) is a personal command center for managing goals, tasks,
            projects, habits and finances. The App is provided by Pewnosc Siebie AI (the
            “Developer”, “we”). This Privacy Policy explains what data we collect, how we use it,
            and your rights.
          </P>
        </Sec>
        <Sec title="Data we collect">
          <Bullets
            items={[
              'Account and login data: your email address and basic profile data (e.g. name, monthly income goal settings).',
              'User-entered content: goals, tasks, projects, habits and finance entries that you create in the App.',
              'Technical and diagnostic data (if applicable): basic error and performance information, used solely to ensure security and stability.',
            ]}
          />
        </Sec>
        <Sec title="How we use data">
          <Bullets
            items={[
              'to provide and operate the App features,',
              'to enable login and account access,',
              'to synchronize your data across sessions and devices,',
              'to respond to requests and provide support,',
              'to ensure security and protect against abuse.',
            ]}
          />
        </Sec>
        <Sec title="No sale of data">
          <P>We do not sell your personal data to any third parties.</P>
        </Sec>
        <Sec title="AI features">
          <P>
            The App includes artificial intelligence features that may process the content you
            enter to generate suggestions, summaries and next steps. See the AI Notice for
            details.
          </P>
        </Sec>
        <Sec title="Data retention and deletion">
          <P>
            We retain your data for as long as you maintain an active account. You can request
            deletion of your account and data at any time via the “Delete account” page or by
            contacting us at {CONTACT_EMAIL}.
          </P>
        </Sec>
        <Sec title="Contact">
          <P>
            Pewnosc Siebie AI · {CONTACT_EMAIL} · {SITE_URL}
          </P>
        </Sec>
        <Sec title="Changes to this Policy">
          <P>
            We may update this Policy from time to time. The latest version will always be
            available at this address.
          </P>
        </Sec>
      </Lang>
    </LegalLayout>
  );
}
